var map = {
	"./add.png": "6e90",
	"./arrow-back.png": "ee85",
	"./calendar.png": "6c68",
	"./car-white.png": "2463",
	"./car.png": "1871",
	"./delete.png": "2dbd",
	"./edit.png": "0f8f",
	"./health-white.png": "3b10",
	"./health.png": "4b3e",
	"./history.png": "60c8",
	"./house-white.png": "5e13",
	"./house.png": "8c19",
	"./moto-white.png": "a967",
	"./moto.png": "a888",
	"./overview.png": "783a",
	"./search.png": "ccef",
	"./tick.png": "c85f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";